import React, { useEffect, useRef } from 'react';

const AutoResizeTextArea = ({ value, onChange, minHeight = 100 }) => {
  const textareaRef = useRef(null);

  const adjustHeight = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      // Reset height to ensure proper calculation
      textarea.style.height = 'inherit';
      // Set the height to scrollHeight to fit all content
      const computed = window.getComputedStyle(textarea);
      const height = textarea.scrollHeight + 
        parseInt(computed.borderTopWidth) + 
        parseInt(computed.borderBottomWidth);
      
      textarea.style.height = `${Math.max(minHeight, height)}px`;
    }
  };

  useEffect(() => {
    adjustHeight();
  }, [value]);

  return (
    <textarea
      ref={textareaRef}
      value={value}
      onChange={onChange}
      style={{
        minHeight: `${minHeight}px`,
        width: '100%',
        resize: 'none',
        overflow: 'hidden',
        padding: '8px',
        boxSizing: 'border-box',
      }}
    />
  );
};

export default AutoResizeTextArea; 